export default function LoadingOverlay() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-opacity-20 backdrop-blur-sm">
      <div className="flex flex-col items-center">
        <span className="animate-spin rounded-full h-12 w-12 border-4 border-t-transparent border-[#113D7B] mb-4" />
        <span className="text-[#113D7B] text-lg font-semibold">Loading...</span>
      </div>
    </div>
  );
}
